<template>
<!-- Main Content -->
<div class="main-div row">
  
</div>
</template>

<script>
// //import CustomersLeftRail from "../components/customers/CustomersLeftRail.vue";
// const CustomersLeftRail = () =>
//   import(/* webpackChunkName: "components-customers-CustomersLeftRail" */ `../components/customers/CustomersLeftRail.vue`);
// //import HistoryCenterRail from "../components/customers/HistoryCenterRail.vue";
// const HistoryCenterRail = () =>
//   import(/* webpackChunkName: "components-customers-HistoryCenterRail" */ `../components/customers/HistoryCenterRail.vue`);
// //import CustomerRightRail from "../components/customers/CustomerRightRail.vue";
// const CustomerRightRail = () =>
//   import(/* webpackChunkName: "components-customers-CustomerRightRail" */ `../components/customers/CustomerRightRail.vue`);

export default {
  // components: {
  //   CustomersLeftRail,
  //   HistoryCenterRail,
  //   CustomerRightRail
  // }
  data() {
    return {};
  },
  created() {
    this.$router.push({ name: "customers" });
  },
  computed: {},
  methods: {},
  watch: {}
};
</script>
